import { render, staticRenderFns } from "./OutOfStockReport.vue?vue&type=template&id=1079ed60&"
import script from "./OutOfStockReport.vue?vue&type=script&lang=js&"
export * from "./OutOfStockReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1079ed60')) {
      api.createRecord('1079ed60', component.options)
    } else {
      api.reload('1079ed60', component.options)
    }
    module.hot.accept("./OutOfStockReport.vue?vue&type=template&id=1079ed60&", function () {
      api.rerender('1079ed60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/OutOfStockReport.vue"
export default component.exports